(function () {
  function digits(value) {
    return (value || '').replace(/\D/g, '').slice(0, 11);
  }

  function formatCuit(value) {
    var number = digits(value);
    if (number.length <= 2) return number;
    if (number.length <= 10) return number.slice(0, 2) + '-' + number.slice(2);
    return number.slice(0, 2) + '-' + number.slice(2, 10) + '-' + number.slice(10);
  }

  function validCuit(value) {
    var number = digits(value);
    if (number.length !== 11) return false;
    var weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i < 10; i++) sum += Number(number[i]) * weights[i];
    var check = 11 - (sum % 11);
    if (check === 11) check = 0;
    return check !== 10 && check === Number(number[10]);
  }

  function field(panel) {
    return panel.querySelector('input[name="attributes[cuit]"]');
  }

  function selectedA(panel) {
    return panel.querySelector('input[name="attributes[factura_a]"][value="si"]').checked;
  }

  function clearError(panel) {
    panel.querySelector('[data-factura-a-error]').hidden = true;
    field(panel).removeAttribute('aria-invalid');
  }

  function update(panel) {
    var isA = selectedA(panel);
    var input = field(panel);
    panel.querySelector('[data-factura-a-details]').hidden = !isA;
    input.required = isA;
    if (!isA) input.value = '';
    clearError(panel);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.factura-a input[name="attributes[factura_a]"]')) return;
    update(event.target.closest('[data-factura-a]'));
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('.factura-a input[name="attributes[cuit]"]')) return;
    event.target.value = formatCuit(event.target.value);
    clearError(event.target.closest('[data-factura-a]'));
  });

  // Delegación: el carrito lateral se inserta por AJAX después de cargar esta página.
  document.addEventListener('submit', function (event) {
    var panel = event.target.querySelector('[data-factura-a]');
    if (!panel) return;
    var input = field(panel);
    if (!selectedA(panel)) {
      input.value = '';
      return;
    }
    if (!validCuit(input.value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.querySelector('[data-factura-a-error]').hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    input.value = formatCuit(input.value);
  }, true);
})();
